var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAudioDefaultCover = function SvgAudioDefaultCover(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 248,
    height: 138,
    viewBox: "0 0 248 138",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "#EFF1F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83 28H79V108H83V28ZM159 42H163V94H159V42ZM73 48H69V88H73V48ZM153 54H149V82H153V54ZM19 58H23V78H19V58ZM99 60H103V76H99V60ZM173 60H169V76H173V60ZM59 58H63V78H59V58ZM199 54H203V82H199V54ZM93 52H89V84H93V52ZM109 52H113V84H109V52ZM29 64H33V72H29V64ZM123 64H119V72H123V64ZM219 64H223V72H219V64ZM143 62H139V74H143V62ZM179 62H183V74H179V62ZM213 62H209V74H213V62ZM39 66H43V70H39V66ZM133 66H129V70H133V66ZM189 66H193V70H189V66ZM53 66H49V70H53V66Z",
    fill: "#B6BBC2"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAudioDefaultCover);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/audio-default-cover.12447e693bb2fd8e2fb590eb40d52839.svg";